import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title: string;
  description: string;
  canonical?: string; // Optional override
  noindex?: boolean; // Explicitly block indexing (for protected routes)
}

export function SEO({ title, description, canonical, noindex = false }: SEOProps) {
  const location = useLocation();
  const baseUrl = 'https://formto.cc';
  const canonicalUrl = canonical || `${baseUrl}${location.pathname}`;

  // Detect if we're on the primary domain (formto.cc exactly, not www or CloudFront)
  const isPrimaryDomain = typeof window !== 'undefined'
    && window.location.hostname === 'formto.cc';

  // Block indexing if: not primary domain OR noindex prop is true
  const shouldNoindex = !isPrimaryDomain || noindex;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Block indexing for non-primary domains (CloudFront, www) or protected routes */}
      {shouldNoindex && (
        <meta name="robots" content="noindex, nofollow" />
      )}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
    </Helmet>
  );
}
